import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#252D3A",
      "fill-opacity": ".7",
      d: "M13.384 5.22a1.98 1.98 0 0 1-1.976-1.976V.5h-8.83A2.58 2.58 0 0 0 0 3.079v15.545A2.58 2.58 0 0 0 2.579 21.2h10.6a2.58 2.58 0 0 0 2.578-2.575V5.22z",
      opacity: ".3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#75787D",
      d: "M15.757 5.22h-2.372a1.98 1.98 0 0 1-1.976-1.976V.5zM12.515 14.954H2.622a.36.36 0 0 1 0-.718h9.893a.359.359 0 0 1 0 .718M12.515 10.907H2.622a.36.36 0 1 1 0-.717h9.893a.36.36 0 0 1 0 .717M12.515 12.93H2.622a.36.36 0 1 1 0-.717h9.893a.359.359 0 0 1 0 .718M8.613 8.884h-5.99a.36.36 0 1 1-.001-.718h5.991a.36.36 0 0 1 0 .718M8.613 6.86h-5.99a.36.36 0 0 1-.001-.717h5.991a.36.36 0 0 1 0 .717M12.34 6.143h-1.694a.535.535 0 0 0-.535.534v1.695c0 .295.24.534.535.534h1.694c.295 0 .534-.24.534-.534V6.677a.535.535 0 0 0-.534-.534"
    }, null, -1)
  ]))]))
}
export default { render: render }